import { Link } from "react-router-dom";
import type { Project } from "@/mocks/projects";

interface ProjectCardProps {
  project: Project;
  large?: boolean;
}

export default function ProjectCard({ project, large = false }: ProjectCardProps) {
  return (
    <Link
      to={`/projects/${project.id}`}
      className={`group relative block cursor-pointer overflow-hidden rounded-lg bg-foreground-950 ${
        large ? "h-[420px] md:h-[520px]" : "h-[280px] md:h-[320px]"
      }`}
    >
      <img
        src={project.cover}
        alt={`${project.title} 시공 사례`}
        title={`${project.title} 동우스톤 시공 프로젝트`}
        className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
        <span className="inline-flex rounded-full bg-background-50/90 px-3 py-1 font-label text-[11px] font-medium text-foreground-800 backdrop-blur-sm">
          {project.category}
        </span>
        <h3 className={`mt-3 font-heading text-background-50 ${large ? "text-2xl md:text-3xl" : "text-xl"}`}>
          {project.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-background-100/80">{project.summary}</p>
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-200/70">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line text-sm" />
            {project.location}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-sm" />
            {project.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-expand-diagonal-line text-sm" />
            {project.area}
          </span>
        </div>
      </div>
    </Link>
  );
}